export default "__VITE_ASSET__DCatrfjJ__"